import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/toaster';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import ClockView from './pages/ClockView';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TournamentEditor from './pages/TournamentEditor';
import TournamentControl from './pages/TournamentControl';
import AccountManager from './pages/AccountManager';

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/join" element={<Navigate to="/" replace />} />
            <Route path="/clock/:code" element={<ClockView />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/accounts" element={<ProtectedRoute requireSuper><AccountManager /></ProtectedRoute>} />
            <Route path="/admin/tournament/new" element={<ProtectedRoute><TournamentEditor /></ProtectedRoute>} />
            <Route path="/admin/tournament/:id/edit" element={<ProtectedRoute><TournamentEditor /></ProtectedRoute>} />
            <Route path="/admin/tournament/:id" element={<ProtectedRoute><TournamentControl /></ProtectedRoute>} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
